import React from "react";
import Accordion from "pages/_components/Accordion";
import { instanceOf } from "prop-types";
import AccordionItem from "pages/_components/AccordionItem";

const Help = ({ list }) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return (
        <div className="help-slider">
            <h1 className="text-center title-content">Ayuda</h1>
            <div className="container">
                <Accordion>
                    {list.map((faq, index) => {
                        const descriptionWithLinks = faq.description.replace(
                            urlRegex,
                            (url) => `<a href="${url}" target="_blank">${url}</a>`,
                        );
                        return (
                            <div className="credit-bills__resumen box box-shadow pb-1" key={faq.title}>
                                <AccordionItem key={`help-item ${Date.now() + index}`} number={index} item={faq.title}>
                                    <div className="horizontal-divider"> </div>
                                    <p
                                        className="helper-item-description"
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML={{ __html: descriptionWithLinks }}
                                    />
                                </AccordionItem>
                            </div>
                        );
                    })}
                </Accordion>
            </div>
        </div>
    );
};

Help.propTypes = {
    list: instanceOf(Array).isRequired,
};

export default Help;
